import {
  Space,
  Row,
  Col,
  Button,
  Table,
  Typography,
  Divider,
  Popover,
  message,
  Form,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {
  ButtonExcel,
  ColumnPopoverDisplay,
  InputFields,
  ListActionButton,
  ModalCustom,
} from "components/common";
import Icons from "assets/icons";
import {itemsInputField as inputFieldsInit, allColumns} from "./config";
import {ColumnProps} from "types/models";
import {pharmacyStoreService, storeService} from "api";
import {
  setListStore,
  setSelectedMedicinesExport,
  setStatusPhieu,
  setTypeForm,
  setTypePhieu,
  updateDetailLo,
} from "redux/reducer/pharmacyStore";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  exportFile,
  formatDateToString,
  isValuable,
  toNumber,
} from "helper/common";
import {
  FORMAT_TIME,
  LOAI_FORM,
  LOAI_PHIEU_KHO,
  TT_PHIEU_KHO,
  tabKeys,
} from "types/enums";
import {components} from "./EditTable";
import {setActiveKey} from "redux/reducer/common";
import Notification from "components/common/notification/notification";
import ButtonPdf from "components/common/ButtonPdf/ButtonPdf";
import ModalExport from "./ModalExport/ModalExport";
import ModalResults from "./ModalResults/ModalResults";
const ListPharmacy = () => {
  const dispatch = useAppDispatch();
  const selectedMedicinesExport = useAppSelector(
    state => state.pharmacyStore.selectedMedicinesExport
  );
  const [idLo, setIdLo] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const modalRef = useRef(null);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [data, setData] = useState<any[]>([]);
  const [inputFields, setInputFields] = useState(inputFieldsInit);
  const listStore = useAppSelector(state => state.pharmacyStore.listStore);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 1000,
  });
  const [columns, setColumns] = useState<ColumnProps[]>(
    allColumns.filter(e => e.show == true)
  );
  useEffect(() => {
    if (activeTab == tabKeys.PHARMACY_STORE.LIST_PHARMACY) {
      if (
        localStorage.getItem("khoUserId") &&
        form.getFieldValue("kho-id") == null
      ) {
        form.setFieldValue(
          "kho-id",
          toNumber(localStorage.getItem("khoUserId"))
        );
        setParams({...params, ...form.getFieldsValue()});
      }
    }
  }, [activeTab]);
  useEffect(() => {
    setColumns(
      allColumns
        .map(col => {
          if (!col.editable) {
            return col;
          }
          return {
            ...col,
            onCell: (record: any) => ({
              record,
              editable: col.editable,
              dataIndex: col.dataIndex,
              title: col.title,
              type: col?.type,
              handleSave,
            }),
          };
        })
        .filter(e => e.show == true)
    );
  }, [data]);
  useEffect(() => {
    setOptionsStore();
    if (form.getFieldValue("kho-id") == null) {
      form.setFieldValue("kho-id", listStore?.[0]?.id);
    }
  }, [listStore]);
  useEffect(() => {
    if (params?.["kho-id"] != null) {
      getListPharmacyInStore(params);
    }
  }, [params]);
  useEffect(() => {
    getListThuoc();
    getListStore();
    // if (localStorage.getItem("khoUserId")) {
    //   form.setFieldValue("kho-id", Number(localStorage.getItem("khoUserId")));
    //   setParams({...params, ...form.getFieldsValue()});
    // }
  }, []);
  const setShowColumns = showColumns => {
    setColumns(showColumns);
  };
  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });

    setData(newData);
  };

  const getListStore = async () => {
    try {
      const res = await pharmacyStoreService.getListStorePhanQuyen(1, 20);
      dispatch(setListStore(res.data));
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy danh sách kho");
    }
  };
  const getListThuoc = async () => {
    try {
      const res = (await storeService.getListMedicineByParams({})) || [];
      inputFields.find(e => e.name == "ten-thuoc").options = res.map(e => {
        return {value: e?.name, label: e?.name};
      });
      setInputFields([...inputFields]);
    } catch (error) {}
  };
  const setOptionsStore = () => {
    const options = listStore.map(e => ({value: e.id, label: e.name}));
    inputFields.find(e => e.name == "kho-id").options = options;
    setInputFields([...inputFields]);
  };
  const getListPharmacyInStore = async params => {
    setLoading(true);
    setSelectedRowKeys([]);
    try {
      const res = await pharmacyStoreService.getListPharmacyInStore(params);
      setLoading(false);
      setTotal(res.total);
      setData(res.data.map(e => ({...e, xuatDuKien: 0, key: e.id})));
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách thuốc");
    }
  };
  const createExportForm = () => {
    if (selectedMedicinesExport.length == 0) {
      message.warning("Chưa chọn thuốc để tạo phiếu xuất");
    } else {
      // detailRef.current.refresh();
      dispatch(setActiveKey(tabKeys.PHARMACY_STORE.DETAIL));
      dispatch(setStatusPhieu(TT_PHIEU_KHO.NHAP));
      dispatch(setTypeForm(LOAI_FORM.TAO_MOI));
      dispatch(setTypePhieu(LOAI_PHIEU_KHO.XUAT));
    }
  };
  const onClickSearch = () => {
    const formValue = form.getFieldsValue();
    const searchFields = {
      ...formValue,
      start: formatDateToString(formValue.start, FORMAT_TIME.dayFull),
      end: formatDateToString(formValue.end, FORMAT_TIME.dayFull),
    };
    setParams({...params, ...searchFields});
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRowKeys);
      dispatch(setSelectedMedicinesExport(selectedRows));
    },

    getCheckboxProps: (record: any) => ({
      disabled: record["tonKho"] == null || record["tonKho"] <= 0, // Column configuration not to be checked
      name: record.name,
    }),
  };
  const onChangePagination = (page, pageSize) => {
    setLimit(pageSize);
    setPage(page);
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const getReportFile = async () => {
    const params = {
      khoId: form.getFieldValue("kho-id"),
      isEmpty: null,
    };

    if (params?.khoId != null) {
      const tenKho = listStore.find(e => e.id == params?.khoId).name;
      exportFile(
        "store/medicine-store/export-ton-kho",
        params,
        `Báo cáo tồn kho - ${tenKho}`
      );
    } else {
      Notification("warning", "Chưa chọn kho để xuất báo cáo");
    }
  };
  const getReportFilePdf = async () => {
    const params = {
      khoId: form.getFieldValue("kho-id"),
      isEmpty: null,
    };

    if (params?.khoId != null) {
      const tenKho = listStore.find(e => e.id == params?.khoId).name;
      exportFile(
        "store/medicine-store/export-ton-kho-pdf",
        params,
        `Báo cáo tồn kho - ${tenKho}`,
        "pdf"
      );
    } else {
      Notification("warning", "Chưa chọn kho để xuất báo cáo");
    }
  };
  const getReportFileTheoVT = async () => {
    const params = {
      khoId: form.getFieldValue("kho-id"),
    };
    if (isValuable(form.getFieldValue("kho-id"))) {
      const tenKho = listStore?.find(e => e.id == params?.khoId)?.name;

      exportFile(
        "store/medicine/export-danh-muc-thuoc",
        params,
        `Báo cáo tồn kho theo vật tư - ${tenKho}`
      );
    } else {
      Notification("warning", "Chưa chọn kho");
    }
  };
  const showModal = () => {
    setIsShowModal(true);
  };
  const handleCancel = () => {
    setIsShowModal(false);
  };

  useEffect(() => {
    allColumns.find(e => e.dataIndex == "index").render = (v, r, index) => {
      return <>{limit * (page - 1) + index + 1}</>;
    };
    allColumns.find(e => e.dataIndex == "action").render = (
      value,
      record,
      index
    ) => {
      return (
        <ListActionButton
          toolTipSave={"Cập nhật thông tin lô"}
          showDetailFunction={() => {
            setIsShowModal(true);
            setIdLo(record?.id);
          }}
          saveFunction={() => {
            const params = {
              id: record.id,
              donGiaXuat: record?.donGiaXuat,
            };
            dispatch(updateDetailLo(params));
            // call api luu thông tin lô
          }}
        ></ListActionButton>
      );
    };
    setColumns([...allColumns]);
  }, [limit, page]);

  return (
    <div className="medicine-container">
      <div className="container">
        <Form form={form} onKeyDown={onKeyDown} tabIndex={0}>
          <Row gutter={[16, 8]}>
            {inputFields && <InputFields data={inputFields} />}
          </Row>
          <Row justify={"end"} style={{marginTop: 8}}>
            <Space>
              <Button
                className="btn-sub"
                icon={<Icons.reload />}
                onClick={() => {
                  form.resetFields();
                  onClickSearch();
                }}
              >
                Xoá tìm kiếm
              </Button>
              <Button
                icon={<Icons.search />}
                type="primary"
                onClick={onClickSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Row>
        </Form>
      </div>
      <div className="container">
        <Space style={{width: "100%"}} direction="vertical">
          <Typography.Text strong>Danh sách thuốc</Typography.Text>
          <Divider type="horizontal" style={{margin: "0"}} />
          <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Space>
                <ButtonExcel onClick={getReportFile}></ButtonExcel>
                <ButtonPdf onClick={getReportFilePdf}></ButtonPdf>
                <ButtonExcel
                  onClick={getReportFileTheoVT}
                  title="Báo cáo tồn kho theo vật tư"
                ></ButtonExcel>
                <Button
                  type="primary"
                  onClick={() => {
                    modalRef?.current?.openModal();
                  }}
                >
                  Xuất báo cáo xuất nhập tồn
                </Button>
              </Space>
            </Col>
            <Col>
              <Space style={{width: "100%"}}>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={allColumns}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>

                <Button
                  icon={<Icons.file />}
                  className="btn-sub"
                  onClick={createExportForm}
                >
                  Tạo phiếu xuất
                </Button>
              </Space>
            </Col>
          </Row>
          {data && (
            <Table
              className="table-store"
              scroll={{x: 1300}}
              rowSelection={{
                type: "checkbox",
                ...rowSelection,
              }}
              pagination={{
                pageSize: limit,
                current: page,
                onChange: onChangePagination,
              }}
              components={components}
              columns={columns}
              dataSource={data}
              bordered={true}
              loading={loading}
            />
          )}
        </Space>
        <ModalCustom title="Báo cáo xuất nhập tồn" centered ref={modalRef}>
          <ModalExport></ModalExport>
        </ModalCustom>
        <ModalResults
          idLo={idLo}
          isShowModal={isShowModal}
          handleOk={showModal}
          handleCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default ListPharmacy;
